import React, { useContext, useState } from 'react'
import { db } from '../firebase'
import { AuthContext } from '../context/AuthContext'
import { doc, updateDoc } from 'firebase/firestore'
import toast from 'react-hot-toast'

const Navbar = () => {
  const {currentUser, userEventCode} = useContext(AuthContext)
  const [showEventSwitcher, setShowEventSwitcher] = useState(false)

  const handleEventSwitch = async (newEventCode) => {
    try {
      await updateDoc(doc(db, "users", currentUser.uid), {
        currentEvent: newEventCode
      });
      toast.success(`Switched to event: ${newEventCode}`);
      setShowEventSwitcher(false);
      // Reload the page to refresh all components with new event
      window.location.reload();
    } catch (error) {
      console.error("Error switching event:", error);
      toast.error("Failed to switch event. Please try again.");
    }
  };

  return (
    <div className='navbar'>
      <div className="navbar-left">
        <span className="logo">Planyt Chat</span>
        {userEventCode && (
          <span className="event-badge">
            {userEventCode}
          </span>
        )}
        
        {/* Event Switcher */}
        {currentUser.events && currentUser.events.length > 1 && (
          <div className="event-switcher">
            <button 
              onClick={() => setShowEventSwitcher(!showEventSwitcher)}
              className="event-switch-btn"
            >
              Switch Event
            </button>
            
            {showEventSwitcher && (
              <div className="event-dropdown">
                <div className="event-dropdown-title">
                  Switch to Event:
                </div>
                {currentUser.events.map(eventCode => (
                  <div 
                    key={eventCode} 
                    className={`event-option ${eventCode === userEventCode ? 'current' : ''}`}
                    onClick={() => eventCode !== userEventCode && handleEventSwitch(eventCode)}
                  >
                    {eventCode} {eventCode === userEventCode && '(Current)'}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default Navbar